export const ensureValue = <T>(value: T | undefined | null): T => {
  if (value === undefined || value === null) {
    debugger;
    throw new Error('Value is undefined or null');
  }

  return value as NonNullable<T>;
};

export const not = <T>(value: T) => !value;

export const isDefined = <T>(value: T | undefined | null): value is T =>
  value !== undefined && value !== null;

// eslint-disable-next-line @typescript-eslint/no-unsafe-function-type
export type Prettify<Type> = Type extends Function
  ? Type
  : Extract<
      {
        [Key in keyof Type]: Type[Key];
      },
      Type
    >;

export const maybe = <T, O = T>(
  value: T | null | undefined,
  parser?: (value: T) => O,
): O | undefined =>
  value === null || value === undefined
    ? undefined
    : parser
      ? parser(value)
      : (value as O);

export type OneOfFlags<T extends PropertyKey> =
  | { [K in T]?: never }
  | {
      [K in T]: { [P in K]: boolean } & Partial<Record<Exclude<T, K>, never>>;
    }[T];

export type Maybe<T> = T | undefined | null;

export type DeepOmit<T, K extends string> =
  T extends Array<infer U>
    ? Array<DeepOmit<U, K>>
    : T extends object
      ? {
          [P in keyof T as P extends K ? never : P]: DeepOmit<T[P], K>;
        }
      : T;
